import React from 'react'
import PropTypes from 'prop-types'
import styles from 'components/Onboarding/FormStyles.module.scss'
import classnames from 'classnames'
import {
  NumberFormField,
} from 'belle-js'
import {
  percentageValidation,
  currencyValidation
} from 'utils/fieldValidations'

const ContributionsFormula = (props) => {
  const { data } = props
  const inputSeparatorstyles = classnames(
    styles.inputSeparatorMargin,
    styles.conditionalfieldSubText,
  )

  return (
    <div className={styles.conditionalFieldsWrapper}>
      <div className={styles.description}>
      Formula Values
      </div>
      <div className={styles.inputWrapper}>
        <NumberFormField
          format="percentage"
          allowDecimal={false}
          name="sepContributionFormulaPercentage"
          className={styles.FormFieldInSection}
          placeholder="100"
          maxLength="3"
          validations={percentageValidation.rules}
          validationErrors={percentageValidation.messages}
          value={data.sepContributionFormulaPercentage || ''}
          required={false} />
      </div>
      <div className={inputSeparatorstyles}>
        of the Employer’s profits that are in excess of
      </div>
      <div className={styles.inputWrapper}>
        <NumberFormField
          format="currency"
          allowDecimal={true}
          name="sepContributionFormulaDollar"
          className={styles.FormFieldInSection}
          placeholder="0"
          validations={currencyValidation.rules}
          validationErrors={currencyValidation.messages}
          value={data.sepContributionFormulaDollar || ''}
          required={false} />
      </div>
    </div>
  )
}

ContributionsFormula.propTypes = {
  data: PropTypes.object.isRequired
}

export default ContributionsFormula



// WEBPACK FOOTER //
// ./src/components/Onboarding/AdditionalDetails/ContributionsFormula/ContributionsFormula.jsx